export * from './catalog-faq';
